"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateSportTopPlayerDto = instanceOfCreateSportTopPlayerDto;
exports.CreateSportTopPlayerDtoFromJSON = CreateSportTopPlayerDtoFromJSON;
exports.CreateSportTopPlayerDtoFromJSONTyped = CreateSportTopPlayerDtoFromJSONTyped;
exports.CreateSportTopPlayerDtoToJSON = CreateSportTopPlayerDtoToJSON;
exports.CreateSportTopPlayerDtoToJSONTyped = CreateSportTopPlayerDtoToJSONTyped;
/**
 * Check if a given object implements the CreateSportTopPlayerDto interface.
 */
function instanceOfCreateSportTopPlayerDto(value) {
    if (!('sport_code' in value) || value['sport_code'] === undefined)
        return false;
    if (!('sort_order' in value) || value['sort_order'] === undefined)
        return false;
    return true;
}
function CreateSportTopPlayerDtoFromJSON(json) {
    return CreateSportTopPlayerDtoFromJSONTyped(json, false);
}
function CreateSportTopPlayerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sport_code': json['sport_code'],
        'player_id': json['player_id'] == null ? undefined : json['player_id'],
        'player_slug': json['player_slug'] == null ? undefined : json['player_slug'],
        'sort_order': json['sort_order'],
    };
}
function CreateSportTopPlayerDtoToJSON(json) {
    return CreateSportTopPlayerDtoToJSONTyped(json, false);
}
function CreateSportTopPlayerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sport_code': value['sport_code'],
        'player_id': value['player_id'],
        'player_slug': value['player_slug'],
        'sort_order': value['sort_order'],
    };
}
